<template>
    <div class="relative">
        <!-- Background -->
        <div :class="animation ? 'moveBg' : ' '">
            <picture>
                <source :srcset="ringBgSmall" media="(max-width: 460px)" class="" />

                <img width="1312" height="872" :src="ringBgBig" class="h-auto" />
            </picture>
            <img
                width="672"
                height="644"
                :src="rightLight"
                class="absolute right-0 top-0"
                :class="animation ? 'bgLight' : ''"
            />
        </div>

        <!-- Start -->
        <Stars :is-win="isWin" :rotateNum="rotateNum" :animation="animation" />

        <div
            class="h-[104%] sm:h-[99%] sm:left-1/2 sm:top-[54.5%] sm:transform sm:-translate-x-1/2 sm:-translate-y-1/2 items-end justify-center absolute left-[2%] bottom-[-12%]"
        >
            <img :src="emptyPic"
                style="height: 100%; width: auto; max-width: unset; z-index: 0; pointer-events: none; opacity: 0"
            />
            <!-- Pointer -->
            <div
                class="absolute w-[27.3%] transform -translate-x-1/2 top-0 left-[50%] -translate-y-1/2 scale-100"
                style="z-index: 2"
                :class="arrowClass"
            >
                <q-img 
                    src="~assets/imgs/target.png" 
                    class="h-full w-full left-0 top-0" 
                />
                <q-img
                    :src="arrowSrc"
                    class="h-full w-full left-0 top-0 absolute"
                    :img-style="{
                        transition: 'none',
                    }"
                />
            </div>

            <div class="">
                <!-- 固定显示的轮盘 -->
                <q-img
                    :src="getRingGameSpanImg(risk + segmentsModel)"
                    class="w-full left-0 top-0 absolute"
                    width="920"
                    height="920"
                    :class="[
                        onceBet ? 'opacity-100' : 'opacity-0',
                    ]"
                    :style="{ transform: `rotate(-${ringState.angle}deg)` }"
                    alt=""
                />
                <!-- 旋转时显示的轮盘 -->
                <q-img
                    :ref="(el) => (targetAnim = el)"
                    :src="getRingGameSpanImg(risk + segmentsModel)"
                    class="w-full left-0 top-0 absolute"
                    :class="[
                        !oForm.isSubmiting && !onceBet
                            ? 'rotate'
                            : oForm.isSubmiting && !isFast
                            ? 'rotateNormal'
                            : 'rotateFast',
                        onceBet ? 'opacity-0' : 'opacity-100',
                    ]"
                    width="920"
                    height="920"
                    :style="{ transform: `rotateZ(-${rotateNum}deg)` }"
                    alt=""
                />
            </div>

            <Result
                :once-bet="onceBet"
                :color="color"
                :risk="risk"
                :segments="segmentsModel"
                :is-submiting="oForm.isSubmiting"
                :result-show="resultShow"
                :win-amount="winAmount"
                :isFast="isFast"
                :delay="delay"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, computed, watch, reactive } from 'vue';
// functions
import { type FormObject } from '~/common/js/bettingToolkit';
import { getRingGameSpanImg } from '~/utils/fileImport';
// components
import Result from './Result.vue';
import Stars from './Stars.vue';
// assets
import { ringConfig } from '~/pages/casino/ringGame/data';
import rightLight from '~/pages/casino/ringGame/imgs/ring_light_big.webp';
import ringBgBig from '~/pages/casino/ringGame/imgs/ring_bg_big.webp';
import ringBgSmall from '~/pages/casino/ringGame/imgs/ring_bg_sm.webp';
import stRedImg from '../../imgs/target/st_red.webp';
import defaultArrow from '@/pages/casino/ringGame/imgs/target/st_gray.webp';

const props = defineProps({
    oForm: {
        type: Object as PropType<FormObject>,
        required: true,
    },
    risk: {
        type: String,
        required: true,
    },
    segmentsModel: {
        type: Number,
        required: true,
    },
    rotateNum: {
        type: Number,
        required: true,
    },
    onceBet: {
        type: Boolean,
        required: true,
    },
    animation: {
        type: Boolean,
        required: true,
    },
    isFast: {
        type: Boolean,
        required: true,
    },
    isWin: {
        type: Boolean,
        required: true,
    },
    resultShow: {
        type: Boolean,
        default: true,
    },
    winAmount: {
        type: Number,
        required: true,
    },
    delay: {
        type: Number,
        default: 900
    }
});
const targetAnim = ref(null);
const { weights } = ringConfig;
const animDist = 2 * 360;
const ringState = reactive({
    angle: 0,
    isAnimIdle: true,
});
// 根据下注结果所对应的指针图片
const arrowSrc = ref(stRedImg);
// 指针动画样式
const arrowClass = ref('arrow-normal');
const segmentAngle = computed(() => {
    return 360 / props.segmentsModel;
});
const color = computed(() => {
    return weights[props.risk.toLowerCase()][props.segmentsModel].find((v, i) => {
        if (i === props.rotateNum) {
            return v;
        }
    });
});
const halfSegmentAngle = computed(() => {
    return segmentAngle.value / 2;
});

const spinTo = (index) => {
    const spin = () => {
        ringState.angle =
            ringState.angle -
            (ringState.angle % 360) +
            animDist +
            (360 / props.segmentsModel) * index +
            halfSegmentAngle.value;
    };
    if (ringState.isAnimIdle) {
        ringState.isAnimIdle = false;
        setTimeout(() => {
            spin();
        }, 0);
    } else {
        spin();
    }
};
/**
 * 获取指针对应的目标图片
 */
const getTargetImg = (color) => {
    let targetImgs = import.meta.glob(`/pages/casino/ringGame/imgs/target/*.{png,webp}`, {
        eager: true,
    });

    const spanImgList = Object.entries(targetImgs).map(([key, value]) => {
        const gameName = key
            .replace('/pages/casino/ringGame/imgs/target/', '')
            .replace('.png', '')
            .replace('.webp', '');
        return [gameName, (value as { default: any }).default];
    });
    const spanImg = spanImgList.find((item) => item[0] == `st_${color}`);
    if (!spanImg){
        console.error('no arrow picture, color:', color); 
        return defaultArrow;
    }
    return spanImg[1];
};

watch(
    () => props.rotateNum,
    (val) => {
        spinTo(val);
        // 下注详情弹框中设置指针图片与下注结果对应
        if (props.onceBet && val > 0){
            arrowSrc.value = getTargetImg(color.value)
        }
    },
    { immediate: true },
);

watch(() => props.onceBet, (newVal) => {
    if (newVal){
        arrowSrc.value = getTargetImg(color.value);
        arrowClass.value = 'arrow-result';
        setTimeout(() => {
            arrowClass.value = 'arrow-normal';
        }, props.delay);
    } else {
        arrowSrc.value = stRedImg;
    }
})
</script>
<style lang="scss" scoped>
.rotate {
    animation: rotate 36s linear infinite;
}

.rotateNormal {
    animation: rotate 0.8s linear infinite;
}
.rotateFast {
    animation: rotate 0.4s linear infinite;
}
.moveBg {
    animation: moveBgAnimation 5s linear infinite;
}
.bgLight {
    animation: bgLightAnimation 2s linear infinite;
}
.arrow-normal {
    transition-duration: 500ms;
    transform: translate(-50%, -50%) scale(1);
}
.arrow-result {
    transition-duration: 50ms;
    transform: translate(-50%, -40%) scale(1.1);
}
@keyframes rotate {
    0% {
        transform: rotateZ(0deg);
    }

    100% {
        transform: rotateZ(360deg);
    }
}

@keyframes moveBgAnimation {
    0% {
        transform: translate(0) scale(1.03);
    }
    50% {
        transform: translate(10px, 10px) scale(1.03);
    }
    100% {
        transform: translate(0) scale(1.03);
    }
}

@keyframes bgLightAnimation {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
